export class Item {

    public valePresente;
    public valor;
    public pontos;
    public quantidade;

    constructor(valePresente?, valor?, pontos?, quantidade?) {
        this.valePresente = valePresente;
        this.valor = valor;
        this.pontos = pontos;
        this.quantidade = quantidade;
    }

    public valorTotal() {
        return this.valor * this.quantidade;
    }

    public pontosTotais() {
        return this.pontos * this.quantidade;
    }
}



// WEBPACK FOOTER //
// ./src/app/resources/classes/item.ts